export const getEducation = (data) => {
  return data?.education;
};

export const getApplication = (data) => {
  return data?.appliedJobs;
};

export const getExperience = (data) => {
  return data?.workExperience;
};

export const getGuarantor = (data) => {
  return data?.guarantors;
};

export const getData = (selection, data) => {
  if (selection === "education") return getEducation(data);
  if (selection === "application") return getApplication(data);
  if (selection === "experience") return getExperience(data);
  if (selection === "guarantor") return getGuarantor(data);
};

// ==== Advance search system ====
export const registrationDuration = [
  "Daily",
  "weekly",
  "Monthly",
  "Quaterly",
  "Yearly",
];

export const workType = [
  "part_time",
  "full_time",
  "weekend",
  "freelance",
  "hybrid",
  "student_job",
];

export const salaryRange = [
  {
    title: "below 50K",
    value: "below_50",
  },
  {
    title: "50K - 100k",
    value: "50k_to_100k",
  },
  {
    title: "100K - 300k",
    value: "100k_to_300k",
  },
  {
    title: "300K - 500k",
    value: "300k_to_500k",
  },
  {
    title: "above 500k",
    value: "above_500k",
  },
];

export const jobAvailability = ["open_to_job", "job_change"];

export const ageBracket = [
  "All",
  "below_18",
  "18_to_25",
  "26_to_30",
  "31_to_35",
  "36_to_40",
  "41_to_45",
  "46_to_50",
  "51_to_55",
  "56_to_60",
];

export const academic_qualifications = [
  // School-Level
  "first_school_leaving_certificate",
  "junior_secondary_school_certificate",
  "senior_secondary_school_certificate",
  "high_school_diploma",

  // Post-Secondary (Tertiary)
  "national_diploma",
  "higher_national_diploma",
  "associate_degree",
  "bachelors_degree",
  "postgraduate_diploma",
  "masters_degree",
  "doctorate_degree",
];

export const sex_type = ["all", "Male", "Female", "Others"];

export const years_of_experience = [
  "less_than_1_year",
  "1_to_2_years",
  "3_to_5_years",
  "6_to_9_years",
  "10_years_and_above",
];

export const getEmployees = (data) => {
  const userData = data?.map((dataValue) => ({
    id: dataValue?._id,
    fullName: `${dataValue?.firstName} ${dataValue?.lastName}`,
    email: dataValue?.email,
    address: dataValue?.address,
    applications: dataValue?.appliedJobs?.length,
    Phone: dataValue?.phoneNumber,
    workExperience: dataValue?.workExperience,
    resume: dataValue?.resume,
    guarantor: dataValue?.guarantors,
  }));
  return userData;
};
